import * as React from 'react';
import { Button } from 'react-bootstrap';
import { openOnBaseImage } from '../../../services/documentDownloadService';
interface IViewOriginalReportButtonProps {
  documentId: string;
}

const ViewOriginalReportButton: React.FunctionComponent<IViewOriginalReportButtonProps> = (
  props
) => {
  return (
    <Button
      variant='outline-primary'
      size='sm'
      data-id={props.documentId}
      onClick={() => openOnBaseImage(null, props.documentId)}
    >
      {'   '}
      View
    </Button>
  );
};

export default ViewOriginalReportButton;
